<template>
  <div class="cooperatePage">
    <page-banner
      :info="{
        url: require('@img/banner_6.jpg'),
        title: $t('cooperate.bannerTitle'),
        text: $t('cooperate.bannerText'),
      }"
    ></page-banner>
    <div class="cases">
      <part-title
        :title="$t('cooperate.title')"
        style="margin-bottom: 70px"
      ></part-title>
      <div class="caseList">
        <div class="container wow fadeInUp">
          <div
            class="caseCard"
            v-for="(item, index) in cardInfoList"
            :key="index"
            :class="{
              last: index == 3,
              bottom: index % 2 == 1,
              'active animate__animated flipInX': cardIndex == index,
            }"
            @mouseover="hoverCase(index)"
          >
            <img
              v-show="cardIndex != index"
              class="cardIcon"
              :src="cardIndex == index ? item.activeIcon : item.icon"
              alt
            />
            <h4 v-show="cardIndex != index">
              {{ $t(`cooperate.cardInfoList.${item.title}`) }}
            </h4>
            <p class="cardText" v-show="cardIndex != index">
              {{ $t(`cooperate.cardInfoList.${item.text}`) }}
            </p>
            <img
              v-show="cardIndex == index"
              class="cardIcon"
              :src="item.activeIcon"
              alt
            />
            <p class="cardActiveText" v-show="cardIndex == index">
              {{ $t(`cooperate.cardInfoList.${item.activeText}`) }}
            </p>
            <img
              v-show="cardIndex == index"
              class="cardBg"
              src="@img/img_box_project@2x.png"
              alt
            />
          </div>
        </div>
      </div>
      <img class="caseImg" src="@img/img_keyboard.png" alt />
    </div>
    <div class="partner container">
      <part-title
        :title="$t('cooperate.title1')"
        class="wow fadeInUp"
      ></part-title>
      <img
        class="partnerLogo wow fadeInUp"
        data-wow-delay="0.2s"
        src="@img/img_logo@2x.png"
        alt
      />
    </div>
    <div class="footerImg">
      <img src="@img/img_neural network@2x.png" alt />
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
import pageBanner from "@/components/banner";
import partTitle from "@/components/title";
import pageFooter from "@/components/footer";
import { WOW } from "wowjs";
export default {
  components: {
    pageBanner,
    partTitle,
    pageFooter,
  },
  data() {
    return {
      cardIndex: -1,
      cardInfoList: [
        {
          icon: require("@img/ico_n_technology@2x.png"),
          activeIcon: require("@img/ico_s_technology@2x.png"),
          title: "title1",
          text: "text1",
          activeText: "activeText1",
        },
        {
          icon: require("@img/ico_n_project@2x.png"),
          activeIcon: require("@img/ico_s_project@2x.png"),
          title: "title2",
          text: "text2",
          activeText: "activeText2",
        },
        {
          icon: require("@img/ico_n_market@2x.png"),
          activeIcon: require("@img/ico_s_market@2x.png"),
          title: "title3",
          text: "text3",
          activeText: "activeText3",
        },
        {
          icon: require("@img/ico_n_union@2x.png"),
          activeIcon: require("@img/ico_s_union@2x.png"),
          title: "title4",
          text: "text4",
          activeText: "activeText4",
        },
      ],
    };
  },
  created() {
    this.wow = new WOW({
      animateClass: "animated",
    });
    this.wow.init();
  },
  methods: {
    hoverCase(index) {
      this.cardIndex = index;
    },
  },
};
</script>

<style lang="less" scoped>
.cooperatePage {
  .cases {
    width: 100%;
    height: 793px;
    padding-top: 70px;
    box-sizing: border-box;
    background: url("./background/img_bg_twill@2x.png") repeat;
    position: relative;
    .caseList {
      position: relative;
      z-index: 1;
      .container {
        display: flex;
        align-items: flex-start;
        .caseCard {
          position: relative;
          width: 280px;
          height: 420px;
          background: #ffffff;
          border-radius: 8px;
          border: 1px solid rgba(51, 51, 51, 0.25);
          display: inline-flex;
          flex-direction: column;
          align-items: center;
          margin-right: auto;
          padding: 40px 20px 0;
          box-sizing: border-box;
          &.last {
            margin-right: 0;
          }
          &.bottom {
            margin-top: 60px;
          }
          &.active {
            background: linear-gradient(180deg, #285bcf 0%, #457dfb 100%);
            box-shadow: 0px 6px 12px 4px rgba(45, 97, 215, 0.4);
            border: none;
          }
          .cardIcon {
            width: 104px;
            height: 104px;
            margin-bottom: 16px;
          }
          h4 {
            font-size: 30px;
            color: #333333;
            font-weight: normal;
            text-align: center;
            margin-bottom: 6px;
            &:after {
              content: "";
              display: block;
              width: 56px;
              height: 2px;
              background: rgba(51, 51, 51, 0.7);
              margin: 0 auto;
              margin-top: 10px;
            }
          }
          .cardText {
            font-size: 18px;
            color: #333333;
            line-height: 32px;
          }
          .cardActiveText {
            font-size: 16px;
            color: #ffffff;
            line-height: 24px;
          }
          .cardBg {
            position: absolute;
            bottom: 0;
            right: 0;
            width: 160px;
            height: 160px;
          }
        }
      }
    }
    .caseImg {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 316px;
      z-index: 0;
    }
  }
  .partner {
    margin-top: 75px;
    .partnerLogo {
      width: 100%;
      margin-top: 40px;
    }
  }
  .footerImg {
    width: 100%;
    img {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/cooperate.vue